// import React from 'react';
// import '../Components/navbar.css';
// import {useRef} from 'react';
// import {FaTimes, FaBars} from 'react-icons/fa';

// function Navbar() {

//     const navRef = useRef();

//     //onclick
//     const showNavbar = ()=>{
//         navRef.current.classList.toggle('responsive-nav')
//     }

//   return (
   
//     <header>  
//         <h2 className='logo'>Logo</h2>   
//         <nav ref={navRef} className='nav'>
//             <a href="#">Home</a>
//             <a href="#">About</a>
//             <a href="#">Contact</a>   
//                <button  className='nav-btn nav-btn-close' onClick={showNavbar}>
//                   <FaTimes/>
//                 </button>
//         </nav> 
//            <button className='nav-btn' onClick={showNavbar}> 
//               <FaBars/>
//             </button>
//     </header>   
//   )
// }

// export default Navbar





//it's working well
// import React from 'react';
// import { useRef } from 'react';
// import {FaTimes, FaBars } from 'react-icons/fa';
// import '../Components/navbar.css';


// function Navbar() {
    
//     const navRef = useRef();

//     const showNavbar = ()=>{
//         navRef.current.classList.toggle('responsive-nav')
//     }

//   return (
//     <header>
//         <h2 className='logo'>Cakes <span>Studio</span></h2>
//         <nav ref={navRef}>
//          <a href="#">Home</a>
//          <a href="#">About Us</a>
//          <a href="#">Contact</a>
//           <button className='btn-nav btn-nav-close' onClick={showNavbar}>
//             <FaTimes />
//           </button>
//         </nav>
//         <button className='btn-nav ' onClick={showNavbar}>
//             <FaBars />
//         </button>
//     </header>
//   )
// }

// export default Navbar




//the new site


import React from 'react';
import {Link} from 'react-router-dom';
import {FaBars} from 'react-icons/fa';
import Zoom from 'react-reveal/Zoom';   // this 2 make reveal from side 2 side
import '../Components/navbar.css'

function Navbar({toggle}) {
 
  return (
    <div>
      
      <nav className='navbar'>
        {/*    REMOVED IT AND LL PUT IT IN ANOTHER WAY 
        <Link>
           <div className="desktop logo">
            The Cakes Studio 
           </div>
        </Link>
         */}

         <h2 className='desktop logo'>The Cakes Studio</h2>
        <div className="navIcon" onClick={toggle}><FaBars  className='icon'/></div>
      </nav>

      {/*
        <Zoom>
           <h2>testing</h2>    will delete this just was testing zoom 
        </Zoom>
        */}
       
    </div>


  )
}

export default Navbar
